import script from "./PieNotaChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PieNotaChart.vue?vue&type=script&setup=true&lang=js"

import "./PieNotaChart.vue?vue&type=style&index=0&id=e477be70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e477be70"]])

export default __exports__